export default __webpack_public_path__ + "static/media/timer.37b5f910.svg";